import { defineMessages } from 'react-intl';

export const scanAtCheckoutScreenMessages = defineMessages({
  screenTitle: {
    defaultMessage: 'Scan at checkout',
    description: 'Scan at checkout | Title',
  },
});
